import React from 'react'
import { Row, Col } from "react-bootstrap";
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'
import * as Constants from "../../../components/constants";

export default class CementeryMapDetailElement extends React.Component {
	
  	render() {
		const toMarker = (cementery, id) => {
			if (!cementery || !cementery.coordinates || !cementery.published) {
				return [];
			}
			const markerPosition = cementery.coordinates?.features?.[0]?.geometry?.coordinates?.[0]?.[0];
			if (!markerPosition) {
				return [];
			}
			return (
				<Marker
					key={id}
					onClick={() => { window.open('/cemetery/' + cementery.id, '_self'); }}
					position={markerPosition}
					title={cementery.name}
					icon={'jfb-ic-cementry-symbol.png'}
					onMouseOver={() => {}}
					onMouseOut={() => {}}
				/>
			);
		};

    	return (
			<div>
	        {this.props.cementeries && this.props.published ? 
	        	<Row>
				<Col>
				
					<LoadScript googleMapsApiKey={Constants.GOOGLE_API_KEY}>
        				<GoogleMap mapContainerStyle={{width: '100%', height: '500px'}} center={Constants.center} zoom={7} options={{streetViewControl: false}}>
          				{this.props.cementeries.flatMap((cementery, id) => toMarker(cementery, id))};
        				</GoogleMap>
      				</LoadScript>
					
				</Col>
			</Row>		
			: 
			<Row>
				<Col>
				
					<LoadScript googleMapsApiKey={Constants.GOOGLE_API_KEY}>
        				<GoogleMap mapContainerStyle={{width: '100%', height: '500px'}} center={Constants.center} zoom={7} options={{streetViewControl: false}}>
          				{this.props.cementeries.flatMap((cementery, id) => toMarker(cementery, id))};
						
        				</GoogleMap>
      				</LoadScript>
					
				</Col>
			</Row>
			}
			</div>
    )
  }
  
}





